export const Motif = () => {
    return null;
};
